import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {RouterModule} from '@angular/router';
import {InventoryPageComponent} from './components/inventory/inventory-page/inventory-page.component';
import {DrugRecordsTableComponent} from './components/inventory/drug-records-table/drug-records-table.component';
import {InventoryTableComponent} from './components/inventory/inventory-table/inventory-table.component';
import {ReceiveOrderTableComponent} from './components/receive-edi/receive-order-table/receive-order-table.component';
import {OrderHistoryPageComponent} from './components/order-history/order-history-page/order-history-page.component';
import {OrderDetailsTableComponent} from './components/order-history/order-details-table/order-details-table.component';
import {AddInventoryTableComponent} from './components/bulk-add/add-inventory-table/add-inventory-table.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SearchInputModule} from '../shared/components/search-input/search-input.module';
import {MenuModule} from '../shared/components/menu/menu.module';
import {BadgeModule} from '../shared/components/badge/badge.module';
import {TabsModule} from '../shared/components/tabs/tabs.module';
import {InputModule} from '../shared/components/input/input.module';
import {DialogModule} from '../shared/components/dialog/dialog.module';
import {DashboardModule} from '../dashboard/dashboard.module';
import {PinInputModule} from '../shared/components/pin-input/pin-input.module';
import {InputSearchScannerModule} from '../shared/components/input-search-scanner/input-search-scanner.module';
import {ButtonModule} from '../shared/components/button/button.module';
import {AlertModule} from '../shared/components/alert/alert.module';
import {InventoryEmptySplashComponent} from './components/inventory-empty-splash/inventory-empty-splash.component';
import {SearchEmptySplashModule} from '../shared/components/search-empty-splash/search-empty-splash.module';
import {InventoryArchivedTableComponent} from './components/inventory/inventory-archived-table/inventory-archived-table.component';
import {WarningDialogModule} from '../shared/components/warning-dialog/warning-dialog.module';
import {EnterPinDialogModule} from '../shared/components/enter-pin-dialog/enter-pin-dialog.module';
import {ResetPinDialogModule} from '../shared/components/reset-pin-dialog/reset-pin-dialog.module';
import {FormattedDateModule} from '../shared/pipes/formatted-date/formatted-date.module';
import { OrderHistoryTableComponent } from './components/order-history/order-history-table/order-history-table.component';
import { EmptyTableModule } from '../shared/components/empty-table/empty-table.module';
import {FileUploaderModule} from '../shared/components/file-uploader/file-uploader.module';
import { BasicSubscriptionPlanGuard } from '../shared/guards/basic-subscription-plan.guard';
import { OrdersService } from './components/receive-edi/orders.service';
import { DropdownModule } from '../shared/components/dropdown/dropdown.module';
import { OrderDetailsDialogComponent } from './dialogs/order-details-dialog/order-details-dialog.component';
import { OrderFormModule } from '../shared/components/enter-order/order-form/order-form.module';
import { DatepickerInputModule } from '../shared/components/datepicker-input/datepicker-input.module';
import { NavigatedFromPipe } from '../shared/pipes/navigated-from/navigated-from.pipe';
import { NavigatedFromModule } from '../shared/pipes/navigated-from/navigated-from.module';
import { SchedulesFilterModule } from '../shared/components/schedules-filter/schedules-filter.module';
import { LoadInventoryFileUploaderDialogComponent } from './components/bulk-add/add-inventory-table/load-inventory-file-uploader-dialog/load-inventory-file-uploader-dialog.component';
import { ExcelReader } from '../shared/services/excel-reader.service';
import { InventoryLocationsDropdownModule } from '../shared/components/inventory-locations-dropdown/inventory-locations-dropdown.module';
import { TransactionBadgeModule } from '../shared/pipes/transaction-badge/transaction-badge.module';
import { InventoryLocationsFilterModule } from '../shared/components/inventory-locations-filter/inventory-locations-filter.module';
import { FileAttachmentModule } from '../shared/components/file-attachment/file-attachment.module';
import { SalesToProvidersComponent } from './components/sales-to-providers/sales-to-providers.component';
import { SellReturnOrderDialogModule } from './components/sell-return-order-dialog/sell-return-order-dialog.module';
import { GenericTableModule } from '../shared/components/generic-table/generic-table.module';
import { GenericWriteTableModule } from '../shared/components/generic-write-table/genetic-write-table.module';
import { SaleToProviderDetailsComponent } from './components/sales-to-providers/sale-to-provider-details/sale-to-provider-details.component';
import { OrderDetailsDirective } from './directives/order-details.directive';
import { SalesToReverseDistributorsComponent } from './components/sales-to-reverse-distributors/sales-to-reverse-distributors.component';
import { SaleToReverseDistributorDetailsComponent } from './components/sales-to-reverse-distributors/sale-to-reverse-distributor-details/sale-to-reverse-distributor-details.component';
import { ReturnsToWholesalersComponent } from './components/returns-to-wholesalers/returns-to-wholesalers.component';
import { ReturnToWholesalerDetailsComponent } from './components/returns-to-wholesalers/return-to-wholesaler-details/return-to-wholesaler-details.component';
import { InventoryDestructionsComponent } from './components/inventory-destructions/inventory-destructions.component';
import { DestroyInventoryDialogModule } from './components/inventory-destructions/destroy-inventory-dialog/destroy-inventory-dialog.module';
import { InventoryDestructionDetailsComponent } from './components/inventory-destructions/inventory-destruction-details/inventory-destruction-details.component';
import { SideWidgetService } from '../shared/services/side-widget.service';
import { AuditOrderRedirectLinkClassModule } from '../shared/directives/audit-order-redirect-link/audit-order-redirect-link.module';
import { OverflowClassModule } from '../shared/directives/detect-content-overflow/overflow-class.module';
import { CompoundsComponent } from './components/compounds/compounds.component';
import { CreateCompoundDialogModule } from './dialogs/create-compound-dialog/create-compound-dialog.module';
import { ReceiveCompoundDialogModule } from './dialogs/receive-compound-dialog/receive-compound-dialog.module';
import { CompoundDetailsComponent } from './components/compounds/compound-details/compound-details.component';
import { PdfSignatureService } from '../shared/services/pdf-signature-service';
import { AddEditOrderPartyComponent } from './dialogs/add-edit-order-party/add-edit-order-party.component';
import { CheckboxModule } from '../shared/components/checkbox/checkbox.module';
import { SupplierBuyerSaleDetailsModule } from './components/supplier-buyer-sale-details/supplier-buyer-sale-details.module';
import { SupplierBuyerCardModule } from './components/supplier-buyer-sale-details/supplier-buyer-card/supplier-buyer-card.module';
import { SupplierBuyerSaleDetailsComponent } from './components/supplier-buyer-sale-details/supplier-buyer-sale-details.component';
import { BuyerSupplierService } from './services/buyer-supplier.service';
import { YesNoToggleModule } from '../shared/components/yes-no-toggle/yes-no-toggle.module';
import { AddNoteModule } from '../dashboard/components/add-note/add-note.module';
import { BackCountNotResolvedTooltipModule } from '../shared/components/back-count-not-resolved-tooltip/back-count-not-resolved-tooltip.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

const routes = [
  {
    path: 'ndc', component: InventoryPageComponent,
  },
  {
    path: 'bulk-add', component: AddInventoryTableComponent,
  },
  {
    path: 'order-history', component: OrderHistoryPageComponent,
    canActivate: [BasicSubscriptionPlanGuard]
  },
  { path: 'sales-to-providers-history', component: SalesToProvidersComponent },
  { path: 'sales-to-providers-history/:id', component: SaleToProviderDetailsComponent },
  { path: 'sales-to-reverse-distributors-history', component: SalesToReverseDistributorsComponent },
  { path: 'sales-to-reverse-distributors-history/:id', component: SaleToReverseDistributorDetailsComponent },
  { path: 'returns-to-wholesalers-history', component: ReturnsToWholesalersComponent },
  { path: 'returns-to-wholesalers-history/:id', component: ReturnToWholesalerDetailsComponent },
  { path: 'inventory-destructions-history', component: InventoryDestructionsComponent },
  { path: 'inventory-destructions-history/:id', component: InventoryDestructionDetailsComponent },
  { path: 'compounds', component: CompoundsComponent },
  { path: 'compounds/:id', component: CompoundDetailsComponent },

  {
    path: 'order-history/details/:id', component: OrderDetailsTableComponent, data: {
      orderHistory: true,
    },
    canActivate: [BasicSubscriptionPlanGuard]
  },
  {
    path: 'receive-order/:id', component: ReceiveOrderTableComponent,
    canActivate: [BasicSubscriptionPlanGuard]
  },
  {
    path: ':id', component: DrugRecordsTableComponent, data: {
      inventory: true,
    },
  },

];

@NgModule({
  declarations: [
    InventoryTableComponent,
    DrugRecordsTableComponent,
    ReceiveOrderTableComponent,
    OrderHistoryPageComponent,
    OrderDetailsTableComponent,
    AddInventoryTableComponent,
    InventoryPageComponent,
    InventoryEmptySplashComponent,
    InventoryArchivedTableComponent,
    OrderHistoryTableComponent,
    OrderDetailsDialogComponent,
    LoadInventoryFileUploaderDialogComponent,
    SalesToProvidersComponent,
    SaleToProviderDetailsComponent,
    OrderDetailsDirective,
    SalesToReverseDistributorsComponent,
    SaleToReverseDistributorDetailsComponent,
    ReturnsToWholesalersComponent,
    ReturnToWholesalerDetailsComponent,
    InventoryDestructionsComponent,
    InventoryDestructionDetailsComponent,
    CompoundsComponent,
    CompoundDetailsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    SearchInputModule,
    MenuModule,
    BadgeModule,
    TabsModule,
    InputModule,
    FormsModule,
    DialogModule,
   // DashboardModule,
    PinInputModule,
    InputSearchScannerModule,
    ButtonModule,
    AlertModule,
    SearchEmptySplashModule,
    WarningDialogModule,
    EnterPinDialogModule,
    ResetPinDialogModule,
    FormattedDateModule,
    EmptyTableModule,
    FileUploaderModule,
    DropdownModule,
    OrderFormModule,
    DatepickerInputModule,
    NavigatedFromModule,
    SchedulesFilterModule,
    InventoryLocationsDropdownModule,
    TransactionBadgeModule,
    InventoryLocationsFilterModule,
    FileAttachmentModule,
    SellReturnOrderDialogModule,
    GenericTableModule,
    GenericWriteTableModule,
    DestroyInventoryDialogModule,
    AuditOrderRedirectLinkClassModule,
    OverflowClassModule,
    CreateCompoundDialogModule,
    ReceiveCompoundDialogModule,
    SupplierBuyerSaleDetailsModule,
    SupplierBuyerCardModule,
    YesNoToggleModule,
    BackCountNotResolvedTooltipModule,
    AddNoteModule,
    ScrollingModule
    ],
  providers: [
    DatePipe, OrdersService, NavigatedFromPipe, ExcelReader, SideWidgetService, PdfSignatureService, BuyerSupplierService
  ],
})
export class InventoryModule {
}
